<section class="sh-dialog__content -sh-overflow-scrolling">
    <ng-container *ngTemplateOutlet="(loading$ | async) ? loading : content"></ng-container>
</section>

<ng-template #content>
    <div class="sh-card-table-wrapper">
        <table class="sh-card-table">
            <thead>
                <tr>
                    <th scope="col" class="sh-card-table__col">{{ "items.record-errors-dialog.columns.name" | translate }}</th>
                    <th scope="col" class="sh-card-table__col">{{ "items.record-errors-dialog.columns.error" | translate }}</th>
                </tr>
            </thead>
            <tbody>
                @if (!hasErrors) {
                    <td style="width: 2000vw" [attr.colspan]="2">{{ "general.no-results.other" | translate }}</td>
                }

                <ng-container *ngIf="mailToServices$ | async as mailTo">
                    <ng-container *ngFor="let recordErrorPair of recordErrorPairs; let i = index">
                        <tr *ngFor="let error of recordErrorPair.errors">
                            <td style="min-width: 400px">{{ recordErrorPair.recordTitle }}</td>
                            <td style="min-width: 400px" class="sh-preserve-linebreaks sh-wrap-text">{{ error }}</td>
                            <td *ngIf="actionItems$ | async as actionItems" class="sh-card-table__col--small">
                                <sh-action-group *ngIf="actionItems[i] as group" [actionGroup]="group"></sh-action-group>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #loading>
    <sh-notification [message]="'ui.loading' | translate"></sh-notification>
</ng-template>
